import Navigation from './components/Navigation';
import HeroSection from './sections/HeroSection';
import ExperienceSection from './sections/ExperienceSection';
import StorySection from './sections/StorySection';
import ContactSection from './sections/ContactSection';
import './App.css';

function App() {
  return (
    <div className="App">
      <Navigation />
      <main>
        <HeroSection />
        <ExperienceSection />
        <StorySection />
        <ContactSection />
      </main>
    </div>
  );
}

export default App;
